<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">Create Multiple Parcels</h4>
            </div>
            <div class="modal-body">
                <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
                    <div class="first-part">
                        <div class="row m-b-sm">
                            <div class="col-md-2">
                                <label>Incoming/Outgoing</label>
                            </div>
                            <div class="col-md-3" [hidden]="parcelsService.buildingsForUpdate.length < 2">
                                <label>Building</label>
                            </div>
                            <div class="col-md-3">
                                <label>Courier</label>
                            </div>
                            <div class="col-md-4">
                                <label>Date/Time</label>
                            </div>
                        </div>

                        <div class="row">
                            <!-- ___ Incoming / Outgoing ___ -->
                            <div class="col-md-2 padding-none">
                                <div class="parcel-type-switch clearfix">
                                    <input type="radio"
                                           name="inOut"
                                           id="incomingRadio"
                                           [value]="'Incoming'"
                                           [(ngModel)]="inOut">
                                    <label class="col-md-6" for="incomingRadio">Incoming</label>

                                    <input type="radio"
                                           name="inOut"
                                           id="outgoingRadio"
                                           [value]="'Outgoing'"
                                           [(ngModel)]="inOut">
                                    <label class="col-md-6" for="outgoingRadio">Outgoing</label>
                                </div>
                            </div>
                            <!-- ___ Building ___ -->
                            <div class="col-md-3" [hidden]="parcelsService.buildingsForUpdate.length < 2">
                                <div style="position: relative;">
                                    <select class="form-control"
                                            name="buildingId"
                                            [ngModel]="buildingId"
                                            required
                                            (change)="changeBuilding($event.target.value)"
                                            #buildingSelect>
                                        <option value="" hidden></option>
                                        <option *ngFor="let build of parcelsService.buildingsForUpdate"
                                                [value]="build.id">
                                            {{build.name}}
                                        </option>
                                    </select>
                                    <spinner
                                        [spinnerShow]="parcelsService.buildingsForUpdate && parcelsService.buildingsForUpdate.length < 1"></spinner>
                                </div>
                            </div>
                            <!-- ___ Courier / postService ___ -->
                            <div class="col-md-3">
                                <select class="form-control" name="parcelPostServiceId" [ngModel]="parcelPostServiceId">
                                    <option value="" hidden></option>
                                    <option *ngFor="let postService of parcelsService.postServices"
                                            [value]="postService.id">
                                        {{postService.name}}
                                    </option>
                                    <option value="-1">Other</option>
                                </select>
                                <input
                                    type="text"
                                    class="form-control" *ngIf="form.value.parcelPostServiceId == -1"
                                    [(ngModel)]="otherCourierNameModel"
                                    [ngModelOptions]="{standalone: true}"
                                    placeholder="Other Courier">
                            </div>
                            <!-- ___ Date / CreatedAt ___ -->
                            <div class="col-md-4 long-date-field">
                                <mat-form-field class="parcels-datepicker">
                                    <input matInput
                                           [(ngModel)]="date"
                                           name="date"
                                           [matDatepicker]="picker"
                                           (focus)="picker.open()"
                                           (click)="picker.open()"
                                           placeholder="Choose a date" required>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <!-- ___ Time / CreatedAt ___ -->
                                <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker()">
                                    <input id="timepicker1" class="form-control input-small" name="time"
                                           [ngModel]="time">
                                    <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-b-sm">
                        <div class="col-md-1"><label>Unit#</label></div>
                        <div class="col-md-2"><label>Resident</label></div>
                        <div class="col-md-2"><label>Parcel Type</label></div>
                        <div class="col-md-1 number-pieces-header"><label># of Pieces</label></div>
                        <div class="col-md-2"><label>Barcode</label></div>
                        <div class="col-md-3"><label>Description</label></div>
                        <div class="col-md-1 email-notice-header">
                            <label class="img-checkbox" *ngIf="atLeastOneResidentHasEmail()">
                                <input name="allCheckedNotices"
                                       id="allCheckedNotices"
                                       #allCheckedNotices
                                       type="checkbox"
                                       [(ngModel)]="allChecked"
                                       (ngModelChange)="allCheckedChange()">
                                <label for="allCheckedNotices">
                                    <svg-checked></svg-checked>
                                    Email Notice
                                </label>
                            </label>
                            <label *ngIf="!atLeastOneResidentHasEmail()">Email Notice</label>
                        </div>
                    </div>
                    <button type="submit" [disabled]="disabledSubmit" hidden id="formSubmit"></button>
                </form>

                <div class="row m-b-sm multiple-parcels-row" *ngFor="let item of data; let index = index;">
                    <div class="col-md-1">
                        <search-select [(ngModel)]="item.suiteId"
                                       required
                                       (ngModelChange)="changeUnit($event, item, index)"
                                       [data]="suiteToSearchSelect(suites)">
                        </search-select>
                        <input *ngIf="item.suiteId == '0'"
                               class="form-control number-pieces-input"
                               [(ngModel)]="item.suiteNumber"
                               placeholder="Other Unit Number"
                               maxlength="255" required>
                        <spinner [spinnerShow]="buildingSelect.value && !suites.length"></spinner>
                    </div>
                    <div class="col-md-2">
                        <search-select-with-label [(ngModel)]="item.residentId"
                                                  required
                                                  [labelClass]="useParcelsWaiver ? 'fa fa-check': ''"
                                                  [labelNotMatchClass]="useParcelsWaiver ? 'fa fa-times': ''"
                                                  [labelCondition]="'parcelWaiverSigned'"
                                                  [labelPopoverText]="'Waiver Signed'"
                                                  [negativeLabelPopoverText]="'Waiver is not signed'"
                                                  (ngModelChange)="changeResident(+$event, item)"
                                                  [data]="residentsToSearchSelect(item.residents)">
                        </search-select-with-label>
                        <input *ngIf="item.residentId === 0"
                               class="form-control number-pieces-input"
                               placeholder="Other Resident Name"
                               [(ngModel)]="item.residentFullName"
                               maxlength="255" required>
                        <spinner [spinnerShow]="item.suiteId && item.suiteId != 'null' &&
                                                (!item.residents || (item.residents && !item.residents.length))">
                        </spinner>
                    </div>
                    <div class="col-md-2">
                        <select class="form-control form-control__parcel-type padding-none"
                                [(ngModel)]="item.parcelTypeId">
                            <option value="" hidden></option>
                            <option *ngFor="let parcelType of getParcelTypesForSelectedCorporation()"
                                    [value]="parcelType.id">
                                {{parcelType.name}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-1">
                        <input type="number"
                               min="1"
                               class="form-control number-pieces-input"
                               [(ngModel)]="item.numberPieces">
                    </div>
                    <div class="col-md-2">
                        <input type="text" class="form-control number-pieces-input" [(ngModel)]="item.barCode">
                    </div>
                    <div class="col-md-3">
                        <input class="form-control number-pieces-input" [(ngModel)]="item.description" maxlength="255">

                        <!-- Set Resident Email form -->
                        <div *ngIf="item.residentId && item.residentId != '0' && !residentHasEmail(item)"
                             class="user-email-form"
                             #toggleInput>
                            <a *ngIf="!toggleInput.value && canEditDirectory()"
                               (click)="toggleInput.value = !toggleInput.value">
                                Add Email
                            </a>
                            <span *ngIf="toggleInput.value" class="user-email-input">
                                <input #residentEmailInput
                                       email="true"
                                       class="form-control"
                                       pattern="[a-z0-9._%+-_]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                       name="addResidentEmail-{{item.residentId}}">
                                <button type="button" (click)="setResidentEmail(residentEmailInput, item)">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button type="button" (click)="toggleInput.value = false;">
                                    <i class="fa fa-times"></i>
                                </button>
                                <spinner [spinnerShow]="residentEmailInput.spinnerShow"></spinner>
                            </span>
                        </div>

                    </div>
                    <div class="col-md-1">
                        <label class="img-checkbox" *ngIf="residentHasEmail(item)">
                            <input id="emailNotice{{index}}"
                                   type="checkbox"
                                   (change)="noticeCheckboxChange($event)"
                                   [(ngModel)]="data[index].emailNotice">
                            <label for="emailNotice{{index}}">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <img *ngIf="!residentHasEmail(item) && residentHasPhone(item)"
                             class="phone-icon"
                             [title]="residentHasPhone(item)"
                             src="../../../assets/img/phone-icon.png">
                        <img
                            *ngIf="item.residentId && item.residentId != 'null'  && !residentHasEmail(item) && !residentHasPhone(item)"
                            class="phone-icon"
                            title="This resident does not have an email or phone number associated to it. Please update this account."
                            src="../../../assets/img/no-contact-warning.png">
                        <i class="fa fa-trash pull-right" *ngIf="data.length > 1" (click)="deleteRow(index)"
                           title="Delete Row"></i>
                    </div>
                </div>

                <div class="row m-b-sm mtv-primary-color">
                    <div class="col-md-12">
                        <span class="clickable" (click)="addParcel()">
                            <i class="fa fa-plus-circle"></i> Add More
                        </span>
                    </div>
                </div>

                <div class="row text-center m-b-lg">
                    <button type="button"
                            class="btn btn-primary submit-btn"
                            [disabled]="disabledSubmit"
                            (click)="clickSubmit()">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-mass-modal/parcel-mass-modal.component.html